/** Caret Icon
 *
 */
import { TDirection, TSVGProps } from '@unionco/alaris-app-types'

import { TwStyle } from 'twin.macro'

interface IChevronIconProps extends TSVGProps {
    iconDirection?: TDirection
    cssClasses?: TwStyle
}

const ChevronIconDown: React.FC<TSVGProps & { path: string; }> = ({
    className,
    path,
    viewBox,
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M13.1864 5.72361L8.45775 10.4676L3.49818 5.73894L2.10733 7.12971L8.19619 13.2185L14.5458 7.14494L13.1864 5.72361Z" fill="black" />
        </svg>
    )
}

export const ChevronIcon: React.FC<IChevronIconProps> = ({
    iconDirection = 'down',
    ...props
}) => {
    const path = 'M13.1864 5.72361L8.45775 10.4676L3.49818 5.73894L2.10733 7.12971L8.19619 13.2185L14.5458 7.14494L13.1864 5.72361Z'

    switch (iconDirection) {
        case 'right':
            return (
                <ChevronIconDown
                    path={path}
                    style={{ transform: 'rotate(-90deg)' }}
                    {...props}
                />
            )
        case 'down':
            return <ChevronIconDown path={path} {...props} />
        case 'left':
            return (
                <ChevronIconDown
                    path={path}
                    style={{ transform: 'rotate(90deg)' }}
                    {...props}
                />
            )
        case 'up':
            return (
                <ChevronIconDown
                    path={path}
                    style={{ transform: 'rotate(180deg)' }}
                    {...props}
                />
            )
        default:
            return <></>
    }
}

export default ChevronIcon